import {Box, Grid, Paper, Typography} from '@mui/material';

const testimonials = [
  {
    text: "Perfekt für unsere Team-Events! Die Quiz-Runden machen richtig Spaß.",
    author: "Sarah M.",
    role: "Team Lead"
  },
  {
    text: "Endlich ein Quiz-Tool, das auch gut aussieht und Spaß macht!",
    author: "Michael K.",
    role: "Student"
  },
  {
    text: "Tolle Möglichkeit, mit Freunden zu spielen und dabei zu lernen.",
    author: "Lisa R.",
    role: "Lehrerin"
  }
];

export default function Testimonials() {
  return (
    <Box sx={{ mt: 8, position: 'relative', zIndex: 1 }}>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          textAlign: 'center',
          color: 'var(--color-secondary)',
          mb: 4
        }}
      >
        Das sagen unsere Nutzer
      </Typography>
      <Grid container spacing={4}>
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              sx={{
                p: 3,
                height: '100%',
                background: 'rgba(28, 39, 60, 0.4)',
                backdropFilter: 'blur(10px)',
                position: 'relative',
                '&::before': {
                  content: '"\\201C"',
                  position: 'absolute',
                  top: 10,
                  left: 10,
                  fontSize: '4rem',
                  color: 'var(--color-secondary)',
                  opacity: 0.2
                }
              }}
            >
              <Box sx={{ pl: 4 }}>
                <Typography sx={{ 
                  color: 'var(--color-text-primary)',
                  mb: 2,
                  fontStyle: 'italic'
                }}>
                  {testimonial.text}
                </Typography>
                <Typography sx={{ 
                  color: 'var(--color-secondary)',
                  fontWeight: 'bold'
                }}>
                  {testimonial.author}
                </Typography>
                <Typography sx={{ 
                  color: 'var(--color-text-secondary)',
                  fontSize: '0.9rem'
                }}>
                  {testimonial.role}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
} 